import { NAV } from 'chatspot-core/types/LayoutVariants';
import { createContext } from 'react';
export const HostAppContext = /*#__PURE__*/createContext({
  isAppSetupComplete: false,
  isCopilotExpanded: false,
  isGlobalSearchOpen: false,
  isUserScrolling: false,
  setIsAppSetupComplete: () => {},
  setIsCopilotExpanded: () => {},
  setIsGlobalSearchOpen: () => {},
  setIsUserScrolling: () => {},
  sourceHostApp: 'unknown',
  sourceHostAppPathname: '',
  variant: NAV,
  customCopilotId: undefined,
  isPreviewMode: false
});